/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScoreCategory
 */
export interface ScoreCategory {
}

/**
 * Check if a given object implements the ScoreCategory interface.
 */
export function instanceOfScoreCategory(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ScoreCategoryFromJSON(json: any): ScoreCategory {
    return ScoreCategoryFromJSONTyped(json, false);
}

export function ScoreCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoreCategory {
    return json;
}

export function ScoreCategoryToJSON(value?: ScoreCategory | null): any {
    return value;
}

